import React from 'react';
import { TableConsultBillingsMonthStyle } from './style';

export default function TableConsultBillingsMonth({ searchProjectByMonth }) {
  return (
    <TableConsultBillingsMonthStyle>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Rateio T. (%)</th>
          <th>S. Educ</th>
          <th>S. Proj</th>
          <th>Valor T. (R$)</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {searchProjectByMonth &&
          searchProjectByMonth.map((user, index) => {
            return (
              <tr key={index + 1}>
                <td>{user.user.name}</td>
                <td>{user.totalRateio}%</td>
                <td style={{ textAlign: 'right' }}>
                  {user.totalValueCnpj1.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </td>
                <td style={{ textAlign: 'right' }}>
                  {user.totalValueCnpj2.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </td>
                <td style={{ textAlign: 'right' }}>
                  {user.totalValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </td>
                <td className={user.status ? 'complete' : 'incomplete'}>{user.status ? 'Completo' : 'Incompleto'}</td>
              </tr>
            );
          })}
      </tbody>
    </TableConsultBillingsMonthStyle>
  );
}
